import { PagesStore } from "./pages_store_types";

export const selectPage =
  (key: string) =>
  (state: PagesStore): Record<string, any> | undefined =>
    state.pages[key];
